import React, { useState, useEffect } from "react";
import { Button } from "react-bootstrap";
import Modal from "react-bootstrap/Modal";
import { update } from "../libs/dbFunctions";
import { Constants } from "../libs/Constants";
import { formatCurrency } from "../libs/utils";
import StockPriceDisplay from "../components/StockPriceDisplay";
import { loadStockPriceNearDate } from "../libs/stockPricesLib";

const PeriodPageModal = (props) => { 
  const [stockPrice, setStockPrice] = useState(0);
  const [recentStockPrice, setRecentStockPrice] = useState({});

  useEffect(() => {
    async function fetchStockPrice() {
      try {
        let periodEndDate = new Date(props.object.periodEnddate);
        let data = await loadStockPriceNearDate(props.activeCompany, periodEndDate);
        setRecentStockPrice(data);
      } catch (e) {
        console.log(e);
      }
    };
    fetchStockPrice();
  }, [props.activeCompany, props.object.periodEnddate]);

  const onSubmit = async () => {
    let periodObj = Object.assign({
      id: props.object.id,
      periodStartdate : props.object.periodStartdate,
      periodEnddate: props.object.periodEnddate,
      stockPrice: stockPrice,
      activeCompanyId: props.activeCompany.id
    });
    console.log("updating period:" + JSON.stringify(periodObj));
    try {
      await update(Constants.dbTypes.PERIOD, 
        periodObj,
        props.activeCompany.id);
      props.onHide();
    } catch (e) {
      console.log("error doing update", e);
      props.onHide("Could not close period");
    }
  };
  const onCancel = () => {
    props.onHide();
  };
  return (
    <React.Fragment>
      <Modal.Header closeButton>
        <Modal.Title>Set Stock Price</Modal.Title>
      </Modal.Header>

      <Modal.Body>
        <div>
          <span><StockPriceDisplay 
            label="Price:" 
            stockSymbol={props.activeCompany.code}
            activeCompany={props.activeCompany} 
            targetDate={new Date(props.object.periodEnddate)}/></span>
          <input
            type="text"
            className="form-control"
            onChange={(e) => {
              setStockPrice(Number(e.target.value));
            }}
            placeholder={formatCurrency(recentStockPrice.displayPrice) || "Enter Stock Price"}
            aria-label="Enter Stock Price"
            aria-describedby="basic-addon1"
          ></input>
        </div>
      </Modal.Body>
      <Modal.Footer>
        <button
          type="button"
          className="btn btn-primary"
          onClick={onSubmit}
          disabled={stockPrice <= 0}
        >
          Submit
        </button>
        <Button type="button" variant="outline-cancel" onClick={onCancel}>
          Cancel
        </Button>
      </Modal.Footer>
    </React.Fragment>
  );
};
export default PeriodPageModal;
